  var sliders = document.querySelectorAll('.js-image-slider');

  sliders.forEach(function (slider) {
    new Swiper(slider, {
      loop: true,
      watchSlidesProgress: true,
      autoplay: true,
      delay: 8000,
      pagination: {
        el: slider.closest('section').querySelector('.swiper-pagination'),
        type: 'fraction',
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      on: {
        slideChange: function () {
          this.pagination.render();
          this.pagination.update();
        }
      }
    });
  });